import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import classnames from 'classnames'

const Dropzone = ({ uploadButtonText, fullWidth, ...dropZoneProps }) => {
  const [active, setActive] = useState(false)

  const className = classnames({ 'dropzone--active': active }, 'dropzone')
  const onDragEnter = useCallback((e) => {
    e.stopPropagation()
    setActive(true)
  }, [])

  const onDragLeave = useCallback((e) => {
    e.stopPropagation()
    setActive(false)
  }, [])
  const onDragOver = useCallback((e) => {
    e.stopPropagation()
  }, [])

  const { getRootProps, getInputProps } = useDropzone({ onDragEnter, onDragLeave, onDragOver, ...dropZoneProps })
  const rootProps = getRootProps()
  const inputProps = getInputProps()
  return (
    <section className={fullWidth && 'w-100'}>
      <div {...rootProps} className={className}>
        <input {...inputProps} />
        <button className='dropzone__btn'>
          <Icon name='upload' />
          <Resx name={uploadButtonText || 'Common.DragAndDropFile'} />
        </button>
      </div>
    </section>
  )
}

export {
  Dropzone
}



// WEBPACK FOOTER //
// ./src/components/fileAttachments/dropzone.js